module.exports = __webpack_public_path__ + "img/744.27df7dd8.jpg";